/**
 * Utilidad para formatear rutas y evitar dobles barras diagonales
 */

/**
 * Formatea una ruta eliminando dobles barras diagonales y asegurando formato correcto
 * @param {string} enlace - El enlace o ruta a formatear
 * @returns {string} - La ruta formateada correctamente
 */
export function formatRoute(enlace) {
  // Si el enlace está vacío o es null/undefined, retornar ruta raíz
  if (!enlace || enlace.trim() === '') {
    return '/';
  }

  // Convertir a string y limpiar espacios
  let ruta = String(enlace).trim();

  // Si termina en 'View', procesarlo especialmente
  if (ruta.endsWith('View')) {
    let base = ruta.replace('View', '');
    if (base.startsWith('Add')) {
      return `/${base.substring(3).toLowerCase()}/add`;
    }
    if (base.startsWith('Edit')) {
      return `/${base.substring(4).toLowerCase()}/edit`;
    }
    return `/${base.toLowerCase()}`;
  }

  // Asegurar que comience con '/'
  if (!ruta.startsWith('/')) {
    ruta = '/' + ruta;
  }

  // Eliminar barra final si existe (excepto si es solo '/')
  if (ruta.length > 1 && ruta.endsWith('/')) {
    ruta = ruta.slice(0, -1);
  }

  // Eliminar dobles barras diagonales
  ruta = ruta.replace(/\/+/g, '/');

  // Convertir a minúsculas para consistencia
  ruta = ruta.toLowerCase();

  return ruta;
}

/**
 * Combina una ruta base con una ruta relativa evitando dobles barras
 * @param {string} base - La ruta base (ej: '/api')
 * @param {string} relative - La ruta relativa (ej: 'usuarios')
 * @returns {string} - La ruta combinada correctamente
 */
export function combineRoutes(base, relative) {
  if (!base || base.trim() === '') {
    return formatRoute(relative);
  }
  
  if (!relative || relative.trim() === '') {
    return formatRoute(base);
  }

  // Limpiar ambas rutas
  let cleanBase = String(base).trim();
  let cleanRelative = String(relative).trim();

  // Eliminar barra final de la base
  if (cleanBase.endsWith('/')) {
    cleanBase = cleanBase.slice(0, -1);
  }

  // Eliminar barra inicial de la relativa
  if (cleanRelative.startsWith('/')) {
    cleanRelative = cleanRelative.substring(1);
  }

  // Combinar y formatear
  const combined = cleanBase + '/' + cleanRelative;
  return formatRoute(combined);
}

/**
 * Valida si una ruta tiene el formato correcto
 * @param {string} ruta - La ruta a validar
 * @returns {boolean} - true si la ruta es válida
 */
export function isValidRoute(ruta) {
  if (!ruta || typeof ruta !== 'string') {
    return false;
  }

  // Verificar que no tenga dobles barras
  if (ruta.includes('//')) {
    return false;
  }

  // Verificar que comience con '/'
  if (!ruta.startsWith('/')) {
    return false;
  }

  return true;
}